import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveLoanTypes, fetchActiveEmployeeLoans, getloaninstallmentdetails } from "store/actions";
import Loader from "common/pageLoader";

const PayrollApplyLoan = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [data, setdata] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const toggleModal = () => { setIsModalOpen(prev => !prev); };
  const location = useLocation();
  const history = useHistory();
  const [loaninstallments, setloaninstallments] = useState([]);
  const [loaninfo, setloaninfo] = useState([]);
  const [data1, setdata1] = useState(null);
  const {
    loantype,
    employeeloans,
    installment_list,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    loantype: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loantype ?? [],
    employeeloans: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeloans ?? [],
    installment_list: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.installment_list ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
  }));

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveLoanTypes(unitId));
    dispatch(fetchActiveEmployeeLoans(unitId));
  }, [dispatch]);

  let loan_type = [];
  loan_type = (loantype || []).map(item => ({ label: item.loan_name, value: item.loan_id }));

  useEffect(() => {
    if (employeeloans?.length > 0) {
      const generatedData = employeeloans.map((emp, index) => ({
        sno: index + 1,
        loan_id: emp.loan_id,
        emp_no: emp.emp_no,
        emp_name: emp.emp_name,
        department: emp.department,
        emp_id: emp.emp_id,
        loan_no: emp.loan_no,
        loan_amount: emp.loan_amount,
        loan_interest: emp.loan_interest,
        total_installment: emp.total_installment,
        payable_amount: emp.payable_amount,
        loan_start_date: emp.loan_start_date,
        loan_end_date: emp.loan_end_date,
        total_amount: emp.total_amount,
        loan_status_id: emp.loan_status_id,
        loan_status: emp.loan_status
      })) || [];

      setdata(generatedData);
    } else {
      setdata([]);
    }
  }, [employeeloans]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      empName: "",
      empCode: "",
      type: "",
    },
    onSubmit: (values) => {
      console.log("Form Data", values);
    },
  });

  const columns = [
    { Header: "S#", Cell: ({ row }) => data.length - row.index, width: 5, headerClassName: "justify-content-center", },
    { Header: "EMPNO", accessor: "emp_no", width: 100, headerClassName: "text-center", },
    { Header: "NAME", accessor: "emp_name", width: 150, headerClassName: "text-center", },
    { Header: "DEPARTMENT", accessor: "department", width: 150, headerClassName: "text-center", },
    { Header: "LOAN#", accessor: "loan_no", width: 100, headerClassName: "text-center", },
    { Header: "AMOUNT", accessor: "loan_amount", width: 120, headerClassName: "text-center", },
    { Header: "%", accessor: "loan_interest", width: 50, headerClassName: "text-center", },
    { Header: "INSTALLMENTS", accessor: "total_installment", width: 50, headerClassName: "text-center", },
    { Header: "PAYABLE", accessor: "payable_amount", width: 70, headerClassName: "text-center", },
    { Header: "PERIOD_FROM", accessor: "loan_start_date", width: 70, headerClassName: "text-center", },
    { Header: "PERIOD_TO", accessor: "loan_end_date", width: 70, headerClassName: "text-center", },
    { Header: "TOTAL", accessor: "total_amount", width: 100, headerClassName: "text-center", },
    { Header: "STATUS", accessor: "loan_status", width: 100, headerClassName: "text-center", },
    {
      Header: "VIEW",
      width: 100,
      headerClassName: "text-center",
      Cell: (cellProps) => {
        const { id } = cellProps.row.original;
        return (
          <div className="d-flex justify-content-center">
            <Button
              size="sm"
              className="bg-light p-0 border-0 shadow-none"
              onClick={() => ModalOpenid(cellProps.row.original.loan_id)}
            >
              <i className="mdi mdi-eye font-size-18 text-primary"></i>
            </Button>
          </div>
        );
      },
    },
    {
      Header: "ACTION",
      width: 100,
      Cell: (cellProps) => {
        const { id } = cellProps.row.original;
        return (
          <div className="d-flex justify-content-center">
            <Link to="#" className="text-danger" onClick={() => handleDelete(id)}>
              <i className="mdi mdi-close-circle font-size-18" id={`deletetooltip-${id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${id}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        );
      },
    },
  ];

  const ModalOpenid = (id) => {
    setSelectedId(id);
    setIsModalOpen(true);
    const formData = new FormData();
    formData.append("loan_id", id);
    formData.append("unit_id", authDetails?.unit_id);
    dispatch(getloaninstallmentdetails(formData));
  };

  useEffect(() => {
    if (installment_list) { setloaninfo(installment_list.emp_loaninfo[0]); setloaninstallments(installment_list?.emp_loanschdet); }
  }, [installment_list]);

  useEffect(() => {
    if (loaninstallments?.length > 0) {
      const Data = loaninstallments.map((emp, index) => ({
        sno: index + 1,
        current_balance: emp.current_balance,
        installment_amount: emp.installment_amount,
        installment_period: emp.installment_period,
        loan_interest: emp.loan_interest,
        payable_date: emp.payable_date,
        principal_amount: emp.principal_amount,
        paid_status: emp.paid_status
      })) || [];

      setdata1(Data);
    }
  }, [loaninstallments]);

  const Dcolumns = [
    {
      Header: "DATE",
      accessor: "payable_date",
      Footer: () => (
        <div
          style={{
            fontWeight: "700",
            color: "#0c0c0c",
            backgroundColor: "#f2f7f5", // green
            padding: "6px",
            textAlign: "center",
            width: "100%"
          }}
        >
          TOTAL
        </div>
      )
    },
    {
      Header: "PRINCIPAL",
      accessor: "principal_amount",
      Footer: info => {
        const total = info.rows.reduce(
          (sum, row) => sum + Number(row.values.principal_amount || 0),
          0
        );
        return (
          <div
            style={{
              fontWeight: "700",
              color: "#0c0c0c",
              backgroundColor: "#f2f7f5", // green
              padding: "6px",
              textAlign: "center",
              width: "100%"
            }}
          >
            ₹ {total.toLocaleString()}
          </div>
        );
      }
    },
    {
      Header: "MONTHLY_DEDUCTION",
      accessor: "installment_amount",
      Footer: info => {
        const total = info.rows.reduce(
          (sum, row) => sum + Number(row.values.installment_amount || 0),
          0
        );
        return (
          <div
            style={{
              fontWeight: "700",
              color: "#0c0c0c",
              backgroundColor: "#f2f7f5", // green
              padding: "6px",
              textAlign: "center",
              width: "100%"
            }}
          >
            ₹ {total.toLocaleString()}
          </div>
        );
      }
    },
    {
      Header: "INTEREST",
      accessor: "loan_interest",
      Footer: info => {
        const total = info.rows.reduce(
          (sum, row) => sum + Number(row.values.loan_interest || 0),
          0
        );
        return (
          <div
            style={{
              fontWeight: "700",
              color: "#0c0c0c",
              backgroundColor: "#f2f7f5", // green
              padding: "6px",
              textAlign: "center",
              width: "100%"
            }}
          >
            ₹ {total.toLocaleString()}
          </div>
        );
      }
    },
    { Header: "PERIODS", accessor: "installment_period" },
    { Header: "BALANCE", accessor: "current_balance" },
    { Header: "PAID_STATUS", accessor: "paid_status" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll / Employee Loan" breadcrumbItem="Loan Apply" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  {/* Employee Name */}
                  <Col md="4">
                    <FormGroup>
                      <Label for="empName">
                        Emp Name
                      </Label>
                      <Input
                        id="empName"
                        name="empName"
                        type="text"
                        value={formik.values.empName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.empName && Boolean(formik.errors.empName)}
                      />
                      {formik.touched.empName && formik.errors.empName && (
                        <div className="text-danger">{formik.errors.empName}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Employee Code */}
                  <Col md="4">
                    <FormGroup>
                      <Label for="empCode">
                        Emp Code
                      </Label>
                      <Input
                        id="empCode"
                        name="empCode"
                        type="text"
                        value={formik.values.empCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.empCode && Boolean(formik.errors.empCode)}
                      />
                      {formik.touched.empCode && formik.errors.empCode && (
                        <div className="text-danger">{formik.errors.empCode}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Type Select */}
                  <Col md="4">
                    <FormGroup>
                      <Label for="type">
                        Type
                      </Label>
                      <CustomSelect
                        id="loan_types"
                        name="loan_types"
                        isMulti={false}
                        options={loan_type || []}
                        value={formik.values.loan_types || null}
                        onChange={(selectedOption) => { formik.setFieldValue("loan_types", selectedOption); }}
                        onBlur={() => formik.setFieldTouched("loan_types", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </FormGroup>
                  </Col>

                  {/* Buttons */}
                  <Col className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className="btn button-search me-2">
                      <i className="fas fa-search me-1" /> Search
                    </Button>
                    <Link to={`/payroll-create-loan`}>
                      <Button type="button" className="btn button-add me-2">
                        <i className="fas fa-plus me-1" /> Add
                      </Button>
                    </Link>
                    <Button type="reset" className="btn button-cancel me-2" onClick={formik.resetForm}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data && data?.length > 0 ? data : []}
                isGlobalFilter={true}
                customPageSize={10}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal} className="bg-primary  p-3" >
          <p style={{ color: "#fff" }}>Employee Information</p>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body p-2">
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" disabled value={loaninfo.emp_name} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Loan Number</label>
                <input type="text" className="form-control" disabled value={loaninfo.loan_no} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Date</label>
                <input type="text" className="form-control" disabled value={loaninfo.loan_start_date} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Loan Amount</label>
                <input type="text" className="form-control" disabled value={loaninfo.loan_amount} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Interest</label>
                <input type="text" className="form-control" disabled value={loaninfo.loan_interest} />
              </div>

              <div className="col-md-6">
                <label className="form-label">No of installments</label>
                <input type="text" className="form-control" disabled value={loaninfo.total_installment} />
              </div>
            </div>
          </div>
          <div className="modal-header bg-primary text-white p-3">
            <p className="text-white m-0">Installments</p>
          </div>
          <div className="modal-body p-1">
            <div className="row">
              <TableContainer
                columns={Dcolumns}
                data={data1 && data1?.length > 0 ? data1 : []}
                isGlobalFilter={false}
                customPageSize={10}
                showFooter={true}
              />
            </div>
          </div>
          {/* You can call API here using selectedId and show data */}

        </ModalBody>
        {/* <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter> */}
      </Modal>
    </React.Fragment>
  );
};

export default PayrollApplyLoan;
